// hooks/useNumberOfAssets.js

import { getValueFromRawData } from "../utils/utils";

/**
 * Hook to extract number of assets from raw data for text or summary displays.
 * @param {Array} rawData - The raw data fetched from the API.
 * @param {string} energySource - The name of the energy source like pv (solarpower) or wp (windpower).
 * @param {string} category - The category for which assets should be analyzed, like Balcony or a power category Power_0_10.
 * @returns {{
 *   data: number,
 *   error: Error|null,
 *   loading: boolean
 * }} - The number of assets, possible error and loading state.
 */
export const useNumberOfAssets = (rawData, energySource, category) => {
  if (!rawData) {
    return { data: 0, error: null, loading: true };
  }

  try {
    const numberOfAssets = getValueFromRawData(rawData, `${energySource.toUpperCase()}_${category}_Number_Of_Active_Assets`);

    return {
      data: numberOfAssets,
      error: null,
      loading: false,
    };
  } catch (err) {
    console.error("Error extracting number of assets:", err);
    return {
      data: 0,
      error: err,
      loading: false,
    };
  }
};
